module.exports = __webpack_public_path__ + "static/media/kir.96c86cb0.svg";